;(function ($) {

	$(document).ready(function(){

        $('.testimonial-slider-photos').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            prevArrow: jQuery('#box-slick-previous'),
            nextArrow: jQuery('#box-slick-next'),
            asNavFor: '.testimonial-slider-quotes'
        });
        $('.testimonial-slider-quotes').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.testimonial-slider-photos',
            dots: false,
            centerMode: false,
            focusOnSelect: false
        });

		$('.services-slider-text').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.services-slider-photos'
        });
        $('.services-slider-photos').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.services-slider-text',
            dots: true,
            centerMode: false,
			fade: true,
			arrows: false,
            focusOnSelect: false
        });



	});


	$(window).load(function(){

		setTimeout(function(){
	        jQuery("#preloader").fadeOut(300);
			jQuery('.home-hero').addClass('home-hero-animating');
			jQuery('.home header#one').addClass('fade-in-header');

    	}, 3000);


	});


	$(window).resize(function(){


	});

	$( "#blue_service_button" ).mousemove(function( event ) {
		var button = $( "#blue_service_button" );
		var offset = button.offset();
		var offsetLeft = offset.left;
		var offsetTop = offset.top;

		var x = event.pageX - offsetLeft;
		var y = event.pageY - offsetTop;

		event.target.style.setProperty('--x', x + 'px');
		event.target.style.setProperty('--y', y + 'px');

	});


})(jQuery);
